import { useEffect } from "react";
import { useCookieConsent } from "../../hooks/useCookieConsent";

const META_PIXEL_ID = "1338523345027362";

let scriptInjected = false;
let pixelInitialized = false;

function injectMetaPixelScript(): void {
  if (scriptInjected || typeof window === "undefined") {
    return;
  }

  scriptInjected = true;

  (function (f, b, e, v) {
    if (f.fbq) {
      return;
    }
    const n = function (...args: unknown[]) {
      if (n.callMethod) {
        n.callMethod(...args);
      } else {
        n.queue.push(args);
      }
    } as {
      (...args: unknown[]): void;
      callMethod?: (...args: unknown[]) => void;
      queue: unknown[][];
      push: typeof n;
      loaded: boolean;
      version: string;
    };

    f.fbq = n;
    if (!f._fbq) {
      f._fbq = n;
    }
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];

    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
}

function initMetaPixel(): void {
  if (pixelInitialized || typeof window.fbq !== "function") {
    return;
  }

  window.fbq("init", META_PIXEL_ID);
  pixelInitialized = true;
}

export function trackMetaEvent(eventName: string): void {
  if (typeof window === "undefined" || typeof window.fbq !== "function") {
    return;
  }

  window.fbq("track", eventName);
}

type MetaPixelProps = {
  location: Location;
};

export default function MetaPixel({ location }: MetaPixelProps) {
  const { status } = useCookieConsent();

  useEffect(() => {
    if (status !== "accepted") {
      return;
    }

    injectMetaPixelScript();
    initMetaPixel();
    window.fbq?.("track", "PageView");
  }, [status, location.pathname]);

  return null;
}
